const getLatAndLong = () => {
    //console.log("WTF1");
    return new Promise((resolve, reject) => {
        //console.log("WTF2");
        if (!window.navigator.geolocation) {
            console.log("geoLocation broken 1");
            reject('Geolocation is not supported by your browser');
        } else {
            //console.log("WTF3");
            window.navigator.geolocation.getCurrentPosition((position) => {
                const latitude  = position.coords.latitude;
                const longitude = position.coords.longitude;
               // console.log("WTF4");
                resolve({
                    latitude,
                    longitude,
                });
            }, () => {
                //console.log("geoLocation broken 2");
                reject('Blocked the Geolocation service')
            },
            {
                timeout: 5000
            }
            );
        }
    });
};

export default getLatAndLong;
